import { Subject, takeUntil } from 'rxjs';

export function CancelPreviousApiCall() {
  const cancelKey = Symbol('cancelPrevious$');

  return function (
    target: any,
    propertyKey: string,
    descriptor: PropertyDescriptor
  ) {
    const originalMethod = descriptor.value;

    descriptor.value = function (...args: any[]) {
      if (!this[cancelKey]) {
        this[cancelKey] = new Subject<void>();
      }

      this[cancelKey].next();

      return originalMethod.apply(this, args).pipe(takeUntil(this[cancelKey]));
    };

    return descriptor;
  };
};
